import { mapState, mapActions, mapGetters } from 'vuex'

export const authComputed = {
  ...mapState('user', ['currentUser']),
  ...mapGetters('auth', [
    'adminAuthError',
    'shouldStartNotificationLoop',
    'shouldShowReferralExpiredReminderToast',
    'shouldShowPersonalEmailChangedToast',
    'shouldShowEducationHighlightAsManager',
    'onlinePresencePendingReviewsCount',
    'shouldCheckOnboarding',
  ]),
  ...mapGetters('user', [
    'stateToken',
    'hasHomeFeature',
    'hasLoaPipelineFeature',
    'hasUserProfileFeature',
    'hasMyInfoProfileFeature',
    'hasSmsPromptsFeature',
    'isMottoCorporate',
    'isMottoMembership',
    'canManagePersonnel',
    'canImpersonate',
    'hasMyTechFeature',
    'hasPersonnelFeature',
    'canManageNetworkConnect',
    'canAccessEducation',
    'canAccessEducationAsManager',
    'canAccessEducationDemo',
    'canAccessOnlinePresence',
    'isBoOrOpsManager',
    'seenSurveys',
  ]),
}

export const authMethods = mapActions('auth', ['logIn', 'logInWithOkta', 'logOut'])

export const appsComputed = {
  ...mapGetters('apps', ['allApps', 'favoriteApps', 'isAppFavorite']),
}

export const eventsComputed = {
  ...mapGetters('events', ['allEvents', 'upcomingEvents', 'getEventsOnDate', 'favoriteEvents', 'isEventFavorite']),
}

export const debugOptionsComputed = {
  ...mapGetters('debugOptions', ['debugOptions']),
}

export const resourcesComputed = {
  ...mapGetters('resources', [
    'allResources',
    'favoriteResources',
    'selectedResourceId',
    'isResourceFavorite',
    'selectedResourceCategory',
    'shouldReloadResources',
  ]),
}

export const personnelComputed = {
  ...mapGetters('personnel', ['selectedPersonnelOffice', 'lastProspectIdPrompt', 'prospects']),
}

export const getSavedState = (key, defaultValue = null) => {
  try {
    if (JSON.parse(window.localStorage.getItem(key)) !== null) {
      return JSON.parse(window.localStorage.getItem(key))
    }
    return defaultValue
  } catch (e) {
    return ''
  }
}

export const saveState = (key, state) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(state))
  } catch (e) {}
}

export const removeState = (key) => {
  try {
    window.localStorage.removeItem(key)
  } catch (e) {}
}
